import React from 'react';
import { useScrollToTop } from '../hooks/useScrollToTop';

/**
 * Component that scrolls to the top on route changes
 * This is especially important for mobile devices where users 
 * might otherwise start at the bottom of the page after navigation
 */
export const ScrollToTop: React.FC = () => {
  useScrollToTop();
  return null; // This component doesn't render anything
}; 